export var RewardSelectionTypeEnum;
(function (RewardSelectionTypeEnum) {
    RewardSelectionTypeEnum["BALANCE"] = "BALANCE";
    RewardSelectionTypeEnum["REFERRAL"] = "REFERRAL";
    RewardSelectionTypeEnum["TRANSACTION"] = "TRANSACTION";
    RewardSelectionTypeEnum["USER"] = "USER";
})(RewardSelectionTypeEnum || (RewardSelectionTypeEnum = {}));
//# sourceMappingURL=reward-selection-type.enum.js.map